import getCaseWaterfallIntroducerReport from './case_waterfall_introducer'
import getCaseWaterfallIntroducerTotals from './case_waterfall_introducer_totals'

export default {
  fields: {
    getCaseWaterfallIntroducerReport,
    getCaseWaterfallIntroducerTotals,
  },
}
